<template>
  <main class="container-fluid bg-cover" :class="styleClass">
    <b-alert class="m-4" show v-if="missingParameters" variant="danger">
      {{ $t("externalRequest.messages.missingParameters") }}
    </b-alert>

    <template v-if="!missingParameters">
      <border-layout>
        <h3 slot="header" class="pt-2 text-white text-shadow-primary">
          {{ title }}
        </h3>

        <scrollable class="h-100">
          <b-card no-body class="opaque-90">
            <b-tabs
              card
              justified
              pills
              nav-wrapper-class="bg-transparent scrollable"
            >
              <!--
              ==================================================================
              Request parameters
              ==================================================================
              -->
              <b-tab active>
                <template slot="title">
                  <i class="fa fa-fw fa-euro-sign"></i>
                  <span class="d-none d-md-inline">
                    {{ $t("externalRequest.tabs.main") }}
                  </span>
                  <b-badge
                    variant="danger"
                    v-if="$refs.requestForm && $refs.requestForm.errorCounter"
                  >
                    {{ $refs.requestForm.errorCounter }}
                  </b-badge>
                </template>
                <request-form
                  ref="requestForm"
                  v-model="instance"
                  :errors="validationErrors"
                ></request-form>
              </b-tab>
              <!--
              ==================================================================
              Customer's data
              ==================================================================
              -->
              <b-tab>
                <template slot="title">
                  <i class="fa fa-fw fa-user"></i>
                  <span class="d-none d-md-inline">
                    {{ $t("externalRequest.tabs.customer") }}
                  </span>
                  <b-badge
                    variant="danger"
                    v-if="$refs.customerForm && $refs.customerForm.errorCounter"
                  >
                    {{ $refs.customerForm.errorCounter }}
                  </b-badge>
                </template>
                <customer-form
                  ref="customerForm"
                  v-model="instance"
                  :errors="validationErrors"
                ></customer-form>
              </b-tab>
              <!--
              ==================================================================
              User's data
              ==================================================================
              -->
              <b-tab>
                <template slot="title">
                  <i class="fa fa-fw fa-key"></i>
                  <span class="d-none d-md-inline">
                    {{ $t("externalRequest.tabs.user") }}
                  </span>
                  <b-badge
                    variant="danger"
                    v-if="$refs.userForm && $refs.userForm.errorCounter"
                  >
                    {{ $refs.userForm.errorCounter }}
                  </b-badge>
                </template>
                <user-form
                  ref="userForm"
                  v-model="instance"
                  :errors="validationErrors"
                ></user-form>
              </b-tab>
            </b-tabs>
          </b-card>
        </scrollable>
        <div slot="footer" class="buttons text-right py-2">
          <b-button variant="primary" @click.prevent="submit()">
            {{ $t("common.submit") }}
          </b-button>
        </div>
      </border-layout>
    </template>
  </main>
</template>
<script>
import BaseRequestMixin from "@/public/mixins/BaseRequestMixin";
import CustomerForm from "@/modules/customer/public/CustomerForm";

export default {
  mixins: [BaseRequestMixin],

  components: {
    CustomerForm
  },

  props: {
    styleClass: {
      default: ""
    }
  },

  methods: {
    resetAllErrorCounters() {
      this.$refs.requestForm.resetErrorCounter();
      this.$refs.customerForm.resetErrorCounter();
      this.$refs.userForm.resetErrorCounter();
    }
  }
};
</script>
